/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Domain_Requires_PublicInputs */



/**
* | output |
* | --- |
* | "Share this canvas as “anyone with the link” before publishing it on a domain." |
*
* @param {Canvas_Domain_Requires_PublicInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_domain_requires_public = /** @type {((inputs?: Canvas_Domain_Requires_PublicInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Domain_Requires_PublicInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Teilen Sie dieses Canvas als „Jede Person mit dem Link“, bevor Sie es auf einer Domain veröffentlichen.")
	return /** @type {LocalizedString} */ ("Share this canvas as “anyone with the link” before publishing it on a domain.")
});